export const DEFAULT_RADIO_OPT = [{
  id: 'all',
  name: '综合'
}, {
  id: 'count',
  name: '综合指数'
}, {
  id: 'aqi',
  name: 'AQI'
}, {
  id: '1001',
  name: 'SO2'
}, {
  id: '1003',
  name: 'NO2'
}, {
  id: '1005',
  name: 'CO'
}, {
  id: '1006',
  name: 'O3'
}, {
  id: '1007',
  name: 'PM10'
}, {
  id: '1008',
  name: 'PM2.5'
}]



// WEBPACK FOOTER //
// ./src/views/04Statistical-Analysis/04AQI/07TimingAnalysis/defaulData.js